import {
	DELETE_EVENT_REQUEST,
	DELETE_EVENT_REQUEST_CLEAR,
	DELETE_EVENT_REQUEST_FAILED,
	DELETE_EVENT_REQUEST_SUCCESS,
	GET_EVENTS_REQUEST,
	GET_EVENTS_REQUEST_CLEAR,
	GET_EVENTS_REQUEST_FAILED,
	GET_EVENTS_REQUEST_SUCCESS,
	OPEN_EVENT_FORM,
	SAVE_EVENT_REQUEST,
	SAVE_EVENT_REQUEST_CLEAR,
	SAVE_EVENT_REQUEST_FAILED,
	SAVE_EVENT_REQUEST_SUCCESS,
	SET_SELECTED_EVENT,
	SET_SELECTED_EVENTS,
} from "../types"

const initialState = {
	list: [],
	event: {},
	isLoading: false,
	isSaved: false,
	selectedEvents: [],
	openEventForm: false,
	isUpdating: false,
	updateId: undefined,
}

export default function (state = initialState, action) {
	switch (action.type) {
		case GET_EVENTS_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case GET_EVENTS_REQUEST_SUCCESS:
			return {
				...state,
				isLoading: false,
				list: action.payload,
			}
		case GET_EVENTS_REQUEST_FAILED:
			return {
				...state,
				isLoading: false,
				error: action.payload,
			}
		case GET_EVENTS_REQUEST_CLEAR:
			return {
				...state,
				list: [],
				error: undefined,
			}

		case SAVE_EVENT_REQUEST:
			return {
				...state,
				isSaved: false,
				isUpdating: true,
			}
		case SAVE_EVENT_REQUEST_SUCCESS:
			return {
				...state,
				isUpdating: false,
				isSaved: true,
				//event: action.payload,
			}
		case SAVE_EVENT_REQUEST_FAILED:
			return {
				...state,
				isUpdating: false,
				isSaved: false,
				error: action.payload,
			}
		case SAVE_EVENT_REQUEST_CLEAR:
			return {
				...state,
				event: {},
				isSaved: false,
				error: undefined,
			}

		//todo event delete
		case DELETE_EVENT_REQUEST:
			return {
				...state,
				isUpdating: true,
				updateId: action.payload?.id,
			}
		case DELETE_EVENT_REQUEST_SUCCESS:
			return {
				...state,
				isUpdating: false,
				updateId: undefined,
			}
		case DELETE_EVENT_REQUEST_FAILED:
			return {
				...state,
				isUpdating: false,
				updateId: undefined,
				error: action.payload,
			}
		case DELETE_EVENT_REQUEST_CLEAR:
			return {
				...state,
				error: undefined,
			}
		case SET_SELECTED_EVENTS:
			return {
				...state,
				selectedEvents: action.payload,
			}
		case SET_SELECTED_EVENT:
			return {
				...state,
				event: action.payload,
			}
		case OPEN_EVENT_FORM:
			return {
				...state,
				openEventForm: action.payload,
			}
		default:
			return state
	}
}
